<template>
    <div>
        <v-autocomplete
                v-model="model"
                :items="data"
                :label="label"
                :loading="loading"
                :search-input.sync="search"
                :return-object="returnObject"
                cache-items
                :rules="rules"
                clearable
                item-value="id"
                item-text="name"
                :multiple="multi"
                color="primary"
                placeholder="Start typing to Search"
        >
            <v-slide-x-reverse-transition
                    slot="append-outer"
                    mode="out-in"
            >
                <v-icon
                        :key="`icon-${isEditing}`"
                        :color="isEditing ? 'success' : 'info'"
                        @click="isEditing = !isEditing"
                        v-text="isEditing ? 'mdi-check-outline' : 'mdi-circle-edit-outline'"
                ></v-icon>
            </v-slide-x-reverse-transition>
        </v-autocomplete>
    </div>
</template>
<script>
    export default {
        name: "choose-bank-multi",
        props: {
            label: {},
            value: {},
            url: {
                type: String,
                default() {
                    return this.api.ACTIONS.BANKS
                }
            },
            initialSearchParams: {
                type: URLSearchParams,
                default: () => new URLSearchParams()
            },
            multi: {
                type: Boolean,
                default: true
            },
            returnObject: {
                type: Boolean,
                default: false
            },
            rules: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                isEditing: false,
                loading: false,
                model: this.value,
                search: null,
                data: [],
                cached: []
            }
        },
        watch: {
            search(val) {
                this.loading = true;
                const params = new URLSearchParams(this.initialSearchParams);
                params.append("search", val);
                this.axios.get(this.url, {params})
                    .then(res => {
                        const {data} = res.data.data;
                        this.data = data.map(item => ({
                            text: item.name,
                            ...item
                        }));
                    })
                    .catch(err => console.log(err))
                    .finally(() => this.loading = false);
            },
            model(val) {
                this.$emit("input", val);
            },
            value(val) {
                if (!!val)
                    this.data = [...this.data, val];
                this.model = val;
            },
        },
        methods: {
            remove(id) {
                if (!!this.multi)
                    this.model = this.model.filter(item => item !== id);
                else
                    this.model = null;
            }
        }

    }
</script>

<style scoped>

</style>